import { SB } from '@play-co/replicant';
import { tuple } from '../utils/types';

const speciesState = tuple('unlocked', 'veiled', 'unveiled');

export type SpeciesState = (typeof speciesState)[number];

export const encyclopediaSchema = {
  encyclopedia: SB.object({
    speciesState: SB.map(SB.tuple(speciesState)),
    speciesNotification: SB.map(SB.boolean()),
  }),
};
